import {useCallback, useRef} from 'react';

// A key per drawer that stays with it as drawers go in or come out above it,
// so each drawer's fields keep their own state. Keyed by list position, a
// drawer would take over the fields of the one that was there, runner list
// and all, and have its runner picked again from that list. A count change
// adds or drops keys at the end, as the count adds or drops drawers there.
export const useDrawerKeys = (count: number) => {
    const keys = useRef<number[]>([]);
    const issued = useRef(0);

    while (keys.current.length < count) keys.current.push(++issued.current);

    if (keys.current.length > count) keys.current.length = count;

    const insertKey = useCallback((index: number) => {
        keys.current.splice(index, 0, ++issued.current);
    }, []);

    const removeKey = useCallback((index: number) => {
        keys.current.splice(index, 1);
    }, []);

    return {keys: keys.current, insertKey, removeKey};
};
